import { personalInfo } from "../data/index";

export default function Footer() {
  const links = [
    { label: "About", href: "#about" },
    { label: "Skills", href: "#skills" },
    { label: "Projects", href: "#projects" },
    { label: "Experience", href: "#experience" },
    { label: "Contact", href: "#contact" },
  ];

  return (
    <footer
      style={{
        background: "#111111",
        borderTop: "1px solid #2e2e2e",
        padding: "60px 24px 40px",
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            flexWrap: "wrap",
            gap: "40px",
            marginBottom: "48px",
          }}
        >
          {/* brand */}
          <div style={{ maxWidth: "300px" }}>
            <a
              href="#hero"
              style={{
                fontSize: "1.6rem",
                fontWeight: 900,
                color: "#f5f5f5",
                textDecoration: "none",
                display: "inline-block",
                marginBottom: "16px",
              }}
            >
              Ludwig<span style={{ color: "#22d3ee" }}>.</span>
            </a>
            <p
              style={{
                color: "#666",
                fontSize: "0.9rem",
                lineHeight: 1.7,
              }}
            >
              Front-End Engineer specialising in React and modern JavaScript.
              Building things people love to use.
            </p>
          </div>

          {/* nav links */}
          <div>
            <p
              style={{
                color: "#f5f5f5",
                fontWeight: 700,
                fontSize: "0.85rem",
                letterSpacing: "2px",
                textTransform: "uppercase",
                marginBottom: "20px",
              }}
            >
              Navigation
            </p>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
              }}
            >
              {links.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  style={{
                    color: "#666",
                    fontSize: "0.9rem",
                    textDecoration: "none",
                    transition: "color 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = "#22d3ee";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = "#666";
                  }}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* contact */}
          <div>
            <p
              style={{
                color: "#f5f5f5",
                fontWeight: 700,
                fontSize: "0.85rem",
                letterSpacing: "2px",
                textTransform: "uppercase",
                marginBottom: "20px",
              }}
            >
              Get In Touch
            </p>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
              }}
            >
              <a
                href={`mailto:${personalInfo.email}`}
                style={{
                  color: "#666",
                  fontSize: "0.9rem",
                  textDecoration: "none",
                  transition: "color 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = "#22d3ee";
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = "#666";
                }}
              >
                {personalInfo.email}
              </a>
              <a
                href={personalInfo.github}
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "#666",
                  fontSize: "0.9rem",
                  textDecoration: "none",
                  transition: "color 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = "#22d3ee";
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = "#666";
                }}
              >
                github.com/TheNarh
              </a>
              <p style={{ color: "#666", fontSize: "0.9rem" }}>
                📍 {personalInfo.location}
              </p>
            </div>
          </div>
        </div>

        {/* bottom bar */}
        <div
          style={{
            borderTop: "1px solid #2e2e2e",
            paddingTop: "28px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "16px",
          }}
        >
          <p style={{ color: "#444", fontSize: "0.85rem" }}>
            © {new Date().getFullYear()} Ludwig Sackey Narh. Built with{" "}
            <span style={{ color: "#22d3ee" }}>React</span> and lots of ☕
          </p>

          <a
            href="#hero"
            style={{
              background: "rgba(57,255,20,0.08)",
              border: "1px solidrgba(34, 211, 238),0.2)",
              color: "#22d3ee",
              padding: "8px 18px",
              borderRadius: "8px",
              fontSize: "0.85rem",
              fontWeight: 600,
              textDecoration: "none",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(57,255,20,0.15)";
              e.currentTarget.style.boxShadow =
                "0 0 16pxrgba(34, 211, 238),0.2)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgba(57,255,20,0.08)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            Back to top ↑
          </a>
        </div>
      </div>
    </footer>
  );
}
